import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import { List } from 'immutable';

import connectToStores from '../../helpers/connectToStores';
import BaseModal from '../general/BaseModal';
import Icon from '../general/Icon';
import JourneyNotificationStore from '../../stores/JourneyNotificationStore';

import PureRenderComponent from '../PureRenderComponent';

function _getPropsFromStores () {
    return {
        messages: JourneyNotificationStore.get('latestMessages')
    };
}

@connectToStores([JourneyNotificationStore], _getPropsFromStores)
class JourneyNotificationsModal extends PureRenderComponent {

    static propTypes = {
        show: PropTypes.bool,
        messages: PropTypes.instanceOf(List),
        onClose: PropTypes.func,
        onContinue: PropTypes.func
    };

    static defaultProps = {
        messages: new List(),
        show: false,
        onClose: _.noop,
        onContinue: _.noop
    };

    render () {
        const { messages } = this.props;

        const modalProps = {
            show: this.props.show,
            onClose: this.props.onClose,
            onContinue: this.props.onContinue,
            closeText: 'button.text.close',
            continueText: 'button.text.continue',
            titleText: 'booking.search.journey-notification.modal.title',
            className: 'modal--sm'
        };

        const messageElements = messages.map((jnf) => {
            return (<li key={ jnf.id }>{ jnf.message }</li>);
        });

        return (
            <BaseModal { ...modalProps }>
                <section className="text-center">
                    <Icon icon="warning" className="journey-notification__icon" />
                    <div className="text-justify">
                        <ul className="journey-notification__details">
                            { messageElements }
                        </ul>
                    </div>
                </section>
            </BaseModal>
        );
    }

}

export default JourneyNotificationsModal;



// WEBPACK FOOTER //
// ./src/components/search/JourneyNotificationsModal.js